import $ from 'jquery';
import { DisableOnTargetValue } from '../components/disable-on-target-value';
import CustomerDeviceModal from './customer-device-modal';
import { FilterPromotionsByProduct } from '../components/filter-promotions-by-product';

var InputsLogic = (function () {
  'use strict';

  var init = function () {
    if ($('.js__master-checkbox').length && $('.js__slave-checkbox').length) {
      initCheckboxDependantOnSingleCheckbox();
    }
    if ($('.js__toggle-by-input').length) {
      initToggleByInput();
    }

    $('body').on('click', '.js__add-action', e => {
      initToggleByInput();
      FilterPromotionsByProduct.init();
      setTimeout(() => {
        $('.ui.checkbox').checkbox();
        const $closestCollection = $(e.currentTarget).closest('.js__collection-wrapper');
        DisableOnTargetValue.init($closestCollection.length ? $closestCollection : $('body'));
        CustomerDeviceModal.init();
        $('.js__init-ajax-select').each((index, element) => {
          $(element).ajaxInput();
        });
      });
    });
  };

  var initCheckboxDependantOnSingleCheckbox = function () {
    const $masterCheckbox = $('.js__master-checkbox');
    $masterCheckbox.on('change', e => {
      const $slaveCheckbox = $('.js__slave-checkbox');
      if ($(e.currentTarget).prop('checked')) {
        $slaveCheckbox.attr('disabled', false);
      } else {
        $slaveCheckbox.attr('disabled', true);
        $slaveCheckbox.prop('checked', false);
      }
    });

    $masterCheckbox.trigger('change');
  };

  var initToggleByInput = function () {
    setTimeout(() => {
      const $inputs = $('.js__toggle-by-input');
      $inputs.each((index, element) => {
        const $input = $(element);
        $input.on('change', e => {
          toggleByInputChangeHandler($(e.currentTarget));
        });
      });

      $inputs.each((index, element) => {
        toggleByInputChangeHandler($(element));
      });
    });
  };

  var toggleByInputChangeHandler = function ($input) {
    const $targetInput = $input.is('div') ? $input.find('select, input') : $input;
    const $targetWrapper = $targetInput.closest('.js__toggle-by-input-wrapper');
    const elementSelector = $targetInput.data('toggle-element-selector');
    const $elements = $targetWrapper.length ? $targetWrapper.find(elementSelector) : $(elementSelector);
    $elements.each((index, element) => {
      const $element = $(element);
      const conditionValue = $element.data('condition-value');

      if ((conditionValue && conditionValue.includes($targetInput.val())) || $targetInput.prop('checked')) {
        $element.removeClass('hidden').attr('style', '');
      } else {
        $element.addClass('hidden').attr('style', '');
      }
    });
  };

  return {
    init: init,
  };
})();

export default InputsLogic;
